// Fase 4 · P4-B #7 — Helper para emitir <link rel="alternate" hreflang> em
// todas as variantes de subdomínio + x-default. Usar dentro de head().links
// nas rotas SSR indexáveis (nunca em rotas noindex).
import type { LocaleKey } from "@/lib/locale-from-host";

const LOCALE_ORIGINS: Record<LocaleKey, string> = {
  es: "https://www.foradarota.com",
  "pt-BR": "https://br.foradarota.com",
  en: "https://en.foradarota.com",
  "en-EU": "https://eu.foradarota.com",
};

// hreflang tag values (formato ISO 639-1[-Region]).
const HREFLANG: Record<LocaleKey, string> = {
  es: "es",
  "pt-BR": "pt-BR",
  en: "en",
  "en-EU": "en-GB",
};

export interface HreflangLink {
  rel: "alternate";
  hreflang: string;
  href: string;
}

/**
 * Build alternate hreflang links for a given app path (e.g. "/", "/hoteles/123").
 * Emits one <link> per locale + a x-default fallback pointing at the ES origin.
 */
export function buildHreflangLinks(path: string): HreflangLink[] {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const links: HreflangLink[] = (Object.keys(LOCALE_ORIGINS) as LocaleKey[]).map((locale) => ({
    rel: "alternate",
    hreflang: HREFLANG[locale],
    href: `${LOCALE_ORIGINS[locale]}${cleanPath}`,
  }));
  links.push({
    rel: "alternate",
    hreflang: "x-default",
    href: `${LOCALE_ORIGINS.es}${cleanPath}`,
  });
  return links;
}
